
<div class="container py-3 vh-100">
  <!-- Breadcrumbs -->
  <ng-container *ngIf="!this.link; else withLink">
    <app-breadcrumbs
      [segments]="[{ label: breadcrumbLabelDownload, routerLink: '' }]"
    ></app-breadcrumbs>
  </ng-container>
  <ng-template #withLink>
    <app-breadcrumbs
      [segments]="[
        { label: breadcrumbLabelDetails, routerLink: link },
        { label: breadcrumbLabelDownload, routerLink: '' }
      ]"
    ></app-breadcrumbs>
  </ng-template>
  <!-- Fine Breadcrumbs -->
  <div class="container">
    <div
    style="
      min-height: 75vh;
      display: flex;
      justify-content: center;
      align-items: center;
    "
  >
    <div class="text-center">
      <h4 *ngIf="!flag" class="text-black">
        Download dello stampato
      </h4>
      <h4 *ngIf="flag" class="text-danger">
        Il documento richiesto è in corso di aggiornamento
      </h4>
      <a [routerLink]="[lastUrl]">Torna ai dettagli </a>
    </div>
  </div>
  <iframe
    *ngIf="data"
    [src]="data"
    type="application/octet-stream"
    width="100%"
    height="100%"
    style="min-height: 75vh"
  ></iframe>
   
  
</div>
</div>